import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { caseQuickUpdate } from "../../../../lib/fetchApi";
import CheckboxCell from "../../../common/interactive/CheckboxCell";
import CustomSelect from "../../../common/interactive/CustomSelect";
import DatepickerWithLabel from "../../../common/interactive/DatepickerWithLabel";
import InputBox from "../../../common/interactive/InputBox";
import InputBoxCurrency from "../../../common/interactive/InputBoxCurrency";
import { notificationActions } from "../../../../store/notifications";
import { caseActions } from "../../../../store/case";
import { surgicallreadyexistsOnOtherMajorMeds } from "../../../../lib/script";
import { frontendOptions } from "../../../../lib/systemData";

import classes from './MajorMedDepartment.module.css'

export function MajorMedDepartmentDrawerSurgicalItem({surgicalItem, majorMedData, departmentId}) {
    const dispatch = useDispatch()

    const [majorMedDepartmentSurgicalItem, setMjorMedDepartmentSurgicalItem] = useState(null)
    const [noStatusAuthExpDate, setNoStatusAuthExpDate] = useState(true)
    const [itemIsDisabled, setItemIsDisabled] = useState(false)
    const statusOptionsData = useMemo(() => frontendOptions()?.statusOptions || [], [])

    const userToken = useSelector(state => state.user.token)
    const activeCase = useSelector(state => state.case.activeCase)

    useEffect(() => {
        if (majorMedData.major_med_departments) {
            
            let specificDepartment = majorMedData.major_med_departments.find(item => item.department_id == departmentId)
 
            if (specificDepartment && specificDepartment.surgeries && specificDepartment.surgeries.length > 0 && specificDepartment.surgeries.find(item => item.surgery_id == surgicalItem.id)) {      

                setMjorMedDepartmentSurgicalItem(specificDepartment.surgeries.find(item => item.surgery_id == surgicalItem.id))
                setNoStatusAuthExpDate(false)
            } else {
                setMjorMedDepartmentSurgicalItem(null)
                setNoStatusAuthExpDate(true)
            }
        }

        setItemIsDisabled(surgicallreadyexistsOnOtherMajorMeds(majorMedData.id, activeCase, departmentId, surgicalItem.id))
        
        
    }, [activeCase, majorMedData.major_med_departments, departmentId])

    const updateHandler = async (data) => {     
        // first need to verify that the department exists!!!! If not, need to create one the properly update the services in real time
        let specificDepartment = majorMedData.major_med_departments.find(item => item.department_id == departmentId)

        if (!specificDepartment) { // create department
            let departmentreqBody = {
                type: 'case_major_med_departments',
                type_id: data.identifier.type_id, // same as below
                fields: {
                    department_id: departmentId,
                }
            }
    
            let update = await caseQuickUpdate(userToken, activeCase.case.id, departmentreqBody)
    
            if (update && update.errorMessage) {
                dispatch(notificationActions.setError(update))
            } else {            
    
                let dispatchObj = {
                    folder: data.identifier.folder,
                    itemId: data.identifier.type_id,
                    departmentId: data.identifier.department_id,
                    data: update
                }       

                dispatch(caseActions.setDepartmentOnMajorMed(dispatchObj))
            } 
        }     

        // then continue with the rest of the logic.
        let reqBody = {
            type: data.identifier.type,
            type_id: data.identifier.type_id,
            fields: {
                department_id: data.identifier.department_id,
                surgery_id: data.identifier.surgery_id,
                [data.identifier.field] : data.data.value,
            }
        }

        if (data.identifier.field == 'auth_number' || data.identifier.field == 'auth_date') { // if auth number or auth date change the status in approved
            reqBody.fields.status_id = 1
        }

        let update = await caseQuickUpdate(userToken, activeCase.case.id, reqBody)

        if (update && update.errorMessage) {
            dispatch(notificationActions.setError(update))
        } else {  

            let dispatchObj = {
                folder: data.identifier.folder,
                itemId: data.identifier.type_id,
                departmentId: data.identifier.department_id,
                surgicalId: data.identifier.surgery_id,
                data: update
            }
    
    
            dispatch(caseActions.setSurgicalOnMajorMed(dispatchObj))
        }        
        
    }

    return <tr className={`${itemIsDisabled ? classes.item_disabled : ''}`}>                        
        <td>{surgicalItem.rse_area}</td>
        <td className="table-cell-no-padding">
            <CustomSelect optionsData={statusOptionsData} preSelectedValue={majorMedDepartmentSurgicalItem?.status_id} action={updateHandler} identifier={{type: 'case_major_med_department_surgeries', field: 'status', type_id: majorMedData.id, department_id: departmentId, surgery_id: surgicalItem.id, folder: 'major_meds'}} sameSizeAsContainer={true}/>
        </td>
        <td><InputBox currentValue={majorMedDepartmentSurgicalItem?.auth_number} setStyle={'simple'} action={updateHandler} identifier={{type: 'case_major_med_department_surgeries', field: 'auth_number', type_id: majorMedData.id, department_id: departmentId, surgery_id: surgicalItem.id, folder: 'major_meds'}}/></td>
        <td><DatepickerWithLabel textRight={true} defaultDate={majorMedDepartmentSurgicalItem?.auth_date} setStyle={'simple'} action={updateHandler} identifier={{type: 'case_major_med_department_surgeries', field: 'auth_date', type_id: majorMedData.id, department_id: departmentId, surgery_id: surgicalItem.id, folder: 'major_meds'}}/></td>
        
        <td className={`${noStatusAuthExpDate ? classes.item_cell_disabled : ''}`}>
            <CheckboxCell checked={majorMedDepartmentSurgicalItem?.final_verification_completed} action={updateHandler} identifier={{type: 'case_major_med_department_surgeries', field: 'final_verification_completed', type_id: majorMedData.id, department_id: departmentId, surgery_id: surgicalItem.id, folder: 'major_meds'}} setStyle={'centered'}/>
        </td>
        <td className={`${noStatusAuthExpDate ? classes.item_cell_disabled : ''}`}>
            <CheckboxCell checked={majorMedDepartmentSurgicalItem?.copay_coins} action={updateHandler} identifier={{type: 'case_major_med_department_surgeries', field: 'copay_coins', type_id: majorMedData.id, department_id: departmentId, surgery_id: surgicalItem.id, folder: 'major_meds'}}  setStyle={'centered'}/>
        </td>
        <td className={`${noStatusAuthExpDate ? classes.item_cell_disabled : ''}`}>
            <InputBoxCurrency textRight={true} currentValue={majorMedDepartmentSurgicalItem?.deductibles} name={'deductibles'} action={updateHandler} identifier={{type: 'case_major_med_department_surgeries', field: 'deductibles', type_id: majorMedData.id, department_id: departmentId, surgery_id: surgicalItem.id, folder: 'major_meds'}} />
        </td>
        <td className={`${noStatusAuthExpDate ? classes.item_cell_disabled : ''}`}>
            <CheckboxCell checked={majorMedDepartmentSurgicalItem?.paid}  action={updateHandler} identifier={{type: 'case_major_med_department_surgeries', field: 'paid', type_id: majorMedData.id, department_id: departmentId, surgery_id: surgicalItem.id, folder: 'major_meds'}} setStyle={'centered'}/>
        </td>
        <td className={`${noStatusAuthExpDate ? classes.item_cell_disabled : ''}`}>
            <CheckboxCell checked={majorMedDepartmentSurgicalItem?.payment_plan}  action={updateHandler} identifier={{type: 'case_major_med_department_surgeries', field: 'payment_plan', type_id: majorMedData.id, department_id: departmentId, surgery_id: surgicalItem.id, folder: 'major_meds'}} setStyle={'centered'}/>
        </td>
    </tr>
}